module.exports = "/_next/static/images/Cover@2x-9b213114d3c274fd13f800474f3124be.png";